var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.children),function(child){return _c('li',{key:child.uuid},[_vm._v("\n    - "+_vm._s(child.attributes.title)+"\n    "),(child.tree)?_c('RecursiveFolder',{attrs:{"children":child.tree.data,"level":_vm.level + 1}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }